module.exports = function getResource(label, vars = []) {
    let resources = {
        chooseStore: 'Choisir un magasin',
        setYourLocation: 'Définir votre emplacement',
        pickup: 'Ramassage',
        reset: 'Réinitialiser'
    };

    return resources[label];
};
